module.exports = __webpack_public_path__ + "img/6b9272e41809993e71d515df22bc33b2.svg";